import { Browser } from "../../core/browser";
import { Button } from "./button";

export class SplitButton extends Button {
	constructor() {
		super();

		this.buttonID = this.getAttribute("button-id") ?? "";
	}

	parsedCallback() {
		const variationClass = Button.ClassFromVariation(this.variation),
			dropdown = this.querySelector("chip-dropdown");

		const clickable = document.createElementWithContents(this.link ? "a" : "button", [...this.childNodes ?? []].filter(x => !x.matches?.("chip-dropdown")), {
			className: "btn--base split-button-primary",
			type: "button"
		});

		clickable.classList.add(variationClass);
		if (this.buttonClass) { clickable.classList.add(this.buttonClass); }

		if (this.size) { clickable.classList.add(`btn--${this.size.toLowerCase()}`); }
		if (this.buttonStyle) { clickable.classList.add(`btn--${this.buttonStyle.toLowerCase()}`); }
		if (this.icon) { clickable.prepend(document.createElementWithContents("i", null, { className: this.icon })); }

		this.prepend(clickable);

		dropdown.static = true;

		if (this.link) { this.querySelector("a").href = Browser.ResolveRelativeURL(this.link); }
		if (this.buttonID) { this.querySelector(".split-button-primary").id = this.buttonID; }

		const button = this.querySelector("chip-dropdown>div>button");

		if (button) {
			this.#InitDropdown(variationClass, button);
		} else {
			dropdown.onparsed = () => this.#InitDropdown(variationClass);
		}
	}

	#InitDropdown(variationClass, button) {
		button ??= this.querySelector("chip-dropdown>div>button");

		if (this.size) { button.classList.add(`btn--${this.size.toLowerCase()}`); }

		button.classList.add("btn--base", variationClass, "btn--icon");
		button.ariaLabel = Localizer.TOGGLE_DROPDOWN;
		button.appendChild(document.createElementWithContents("i", null, { className: "fas fa-chevron-down" }));

		button.addEventListener("click", ev => ev.stopPropagation());
	}
}